module.exports = __webpack_public_path__ + "assets/0cc2f788c7a39a9d9c2445caf70a35ca.png";